import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "formulario" }
const _hoisted_2 = { class: "container mx-auto max-w-7xl my-7 p-5 lg:p-8 lg:pr-10 bg-white bg-opacity-90 rounded-lg shadow-xl" }
const _hoisted_3 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5" }
const _hoisted_4 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_5 = { class: "text-sm text-red-500 p-error" }
const _hoisted_6 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_7 = { class: "text-sm text-red-500 p-error" }
const _hoisted_8 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_9 = { class: "text-sm text-red-500 p-error" }
const _hoisted_10 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_11 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_12 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_13 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_14 = { class: "text-sm text-red-500 p-error" }
const _hoisted_15 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_16 = { class: "text-sm text-red-500 p-error" }
const _hoisted_17 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_18 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_19 = { class: "text-sm text-red-500 p-error" }
const _hoisted_20 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_21 = { class: "text-sm text-red-500 p-error" }
const _hoisted_22 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_23 = { class: "w-full px-2 md:w-12/12" }
const _hoisted_24 = { class: "text-sm text-red-500 p-error" }
const _hoisted_25 = { class: "flex flex-wrap py-2 mt-3 jusi" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_28 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Form = _resolveComponent("Form")!
  const _component_FullScreenLoader = _resolveComponent("FullScreenLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700 mx-5",
        onInvalidSubmit: _ctx.onInvalidSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _cache[21] || (_cache[21] = _createElementVNode("h1", { class: "font-bold text-center text-2xl" }, "Acreditación de prensa", -1)),
            _cache[22] || (_cache[22] = _createElementVNode("h1", { class: "font-bold text-center text-xl" }, "Por favor complete el formulario", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block mb-1" }, "Documento", -1)),
                _createVNode(_component_Field, {
                  name: "dni",
                  modelValue: _ctx.formData.dni,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dni) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      onBlur: _ctx.validarDni,
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: "Documento"
                    }), null, 16, ["onBlur", "class"]),
                    _createElementVNode("span", _hoisted_5, [
                      _createVNode(_component_ErrorMessage, { name: "dni" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block mb-1" }, "Nombre", -1)),
                _createVNode(_component_Field, {
                  name: "nombre",
                  modelValue: _ctx.formData.nombre,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.nombre) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: "Nombre"
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(_component_ErrorMessage, { name: "nombre" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block mb-1" }, "Apellido", -1)),
                _createVNode(_component_Field, {
                  name: "apellido",
                  modelValue: _ctx.formData.apellido,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.apellido) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: "Apellido"
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_ErrorMessage, { name: "apellido" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block mb-1" }, "País", -1)),
                _createVNode(_component_Select, {
                  modelValue: _ctx.selectedCountry,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCountry) = $event)),
                  filter: "",
                  options: _ctx.paises,
                  optionLabel: "value",
                  placeholder: "Select a Country",
                  class: "input-base"
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block mb-1" }, "Prefijo", -1)),
                (_ctx.selectedCountry !== null)
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 0,
                      type: "text",
                      modelValue: _ctx.selectedCountry.code,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCountry.code) = $event)),
                      class: "input-base",
                      readonly: ""
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block mb-1" }, "Código de área", -1)),
                _createVNode(_component_Field, {
                  name: "codigoArea",
                  modelValue: _ctx.formData.codigoArea,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.codigoArea) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: "Código de área"
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_ErrorMessage, { name: "codigoArea" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block mb-1" }, "Teléfono", -1)),
                _createVNode(_component_Field, {
                  name: "numeroTelefono",
                  modelValue: _ctx.formData.numeroTelefono,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.numeroTelefono) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: "Teléfono"
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_16, [
                      _createVNode(_component_ErrorMessage, { name: "numeroTelefono" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block mb-1" }, "Medio", -1)),
                _createVNode(_component_Field, {
                  name: "medio",
                  modelValue: _ctx.formData.medio,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.medio) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: "Medio"
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_19, [
                      _createVNode(_component_ErrorMessage, { name: "medio" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block mb-1" }, "Ocupación", -1)),
                _createVNode(_component_Field, {
                  name: "ocupacion",
                  modelValue: _ctx.formData.ocupacion,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.ocupacion) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: "Ocupación"
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_21, [
                      _createVNode(_component_ErrorMessage, { name: "ocupacion" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block mb-1" }, "Mail", -1)),
                _createVNode(_component_Field, {
                  name: "mail",
                  modelValue: _ctx.formData.mail,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.mail) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "mail",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: "Mail"
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_24, [
                      _createVNode(_component_ErrorMessage, { name: "mail" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                type: "submit",
                label: "REGISTRARME",
                class: "mt-8 bg-gradient-to-r from-[#e25627] to-[#f1a239] hover:from-[#e94525] hover:to-[#d93b1d] text-white px-4 py-2 rounded-md transition-all duration-200",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_27, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_28, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _cache[20] || (_cache[20] = _createTextVNode(" REGISTRARME "))
              ], 8, _hoisted_26)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"])
    ]),
    _createVNode(_component_FullScreenLoader, { visible: _ctx.isSubmitting }, null, 8, ["visible"])
  ], 64))
}